import React from 'react';
import { Popconfirm } from 'antd';

export default (props) => {
    let {
        index,
        preview,
        previewFn,
        deleteFn,
        show,
        upload
    } = props;

    return <React.Fragment>
        <a
            onClick={() => { previewFn(preview) }}
            className="center"
            title="点击放大"
            href="javascript:;"
            style={{ width: '100%', height: '150px', background: 'url(' + preview + ') no-repeat center/cover' }}
        ></a>
        {
            show
                ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '10px 0 0', overflow: 'hidden', height: '16px' }}>
                    {upload ? upload : null}
                    <Popconfirm
                        placement="topRight"
                        title={'此删除操作不可恢复，确定删除吗？'}
                        onConfirm={() => {
                            deleteFn(index)
                        }}
                        okText="删除"
                        cancelText="取消"
                    >
                        <span className="showClickDetail">删除</span>
                    </Popconfirm>
                </div>
                : null
        }

    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/page/Customer/components/ListAdd/UploadFragment.js